/* import __COLOCATED_TEMPLATE__ from './body.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./body.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());